import { render, staticRenderFns } from "./PageApp.vue?vue&type=template&id=6746c978&"
import script from "./PageApp.vue?vue&type=script&lang=js&"
export * from "./PageApp.vue?vue&type=script&lang=js&"
import style0 from "./PageApp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports